import axiosInstance from './axiosInstance'

export interface ChannelRuleCondition {
  type: 'url_contains' | 'url_param_contains';
  value: string;
  param?: string;
  description?: string;
}

export interface ChannelRuleItem {
  id: string;
  name: string;
  matchMode: 'all' | 'any';
  rules: ChannelRuleCondition[];
  enabled: boolean;
  order: number;
}

export class AdSenseChannelRuleApi {
  static async getList(): Promise<ChannelRuleItem[]> {
    const response = await axiosInstance.get('/cms/v1/adsense/channel-rule')
    return response.data.data.list || []
  }

  static async create(data: Omit<ChannelRuleItem, 'id'>): Promise<ChannelRuleItem> {
    const response = await axiosInstance.post('/cms/v1/adsense/channel-rule', data)
    return response.data.data.rule
  }

  static async update(id: string, data: Omit<ChannelRuleItem, 'id'>): Promise<ChannelRuleItem> {
    const response = await axiosInstance.put(`/cms/v1/adsense/channel-rule/${id}`, data)
    return response.data.data.rule
  }

  static async delete(id: string): Promise<void> {
    await axiosInstance.delete(`/cms/v1/adsense/channel-rule/${id}`)
  }
}
